/** Account identity for private filter preferences; never use an org-only key. */
export function filterOwner(user: { userName?: string; organizationId?: number } | null): string | null {
  return user?.userName && user.organizationId != null
    ? JSON.stringify([user.organizationId, user.userName.toLowerCase()]) : null;
}

export function scopedFilterKey(key: string, owner: string | null): string {
  return `${key}:user:${owner || 'signed-out'}`;
}
